<ul *ngIf="mode === 'list'" class="multiselect-container">
  <div *ngIf="!hideGroups">
    <li *ngIf="groups" class="role-selector">
      <h5 class="user-roles-header">{{locale.LABEL_ROLE_GROUPS}}</h5>
    </li>
    <li *ngFor="let opt of groups" class="role-selector">
      <a href="javascript:void(0);">
        <label class="radio-wrapper">
          <input type="radio" value="{{opt}}" [(ngModel)]="_model.radioModel" [attr.id]="opt" (change)="onRadioModelChange()">{{locale["LABEL_ROLE_GROUPS_" + opt.toUpperCase()] || opt}}</label>
      </a>
    </li>
  </div>
  <li *ngIf="roles" class="role-selector">
    <h5 class="user-roles-header">{{locale.LABEL_USER_ROLES}}</h5>
  </li>
  <!--  TODO: add orderbyPipe-->
  <li *ngFor="let role of roles" class="role-selector" title="{{role}}">
    <a href="javascript:void(0);">
      <label class="checkbox-wrapper">
        <input type="checkbox" [(ngModel)]="_model.checkboxModel[role]" [attr.id]="role"  (change)="onCheckboxModelChange()" >{{role}}</label>
    </a>
  </li>
</ul>

<div *ngIf="mode === 'dropdown'" class="wm-security-multi-select">
  <div class="btn-group" dropdown [isDisabled]="currentPage?.disabled">
    <button type="button" dropdownToggle name="wm-access-level-{{selectedText}}"
      class="multiselect dropdown-toggle btn btn-default" [title]="selectedText || locale.LABEL_ROLE_GROUPS_ + selectedText.toUpperCase()">
      <span class="multiselect-text">
        {{locale["LABEL_ROLE_GROUPS_" + selectedText.toUpperCase()] || selectedText}}
      </span><b class="caret"></b></button>
    <ul id="dropdown-split" *dropdownMenu class="multiselect-container dropdown-menu"
      (click)="$event.stopPropagation()">
      <ng-container *ngIf="showGroups">
        <h5 class="user-roles-header mb-0">{{locale.LABEL_ROLE_GROUPS}}</h5>
        <li *ngFor="let opt of groups" class="role-selector">
          <a href="javascript:void(0);">
            <label class="radio-wrapper">
              <input type="radio" value="{{opt}}" [(ngModel)]="_model.radioModel" [attr.id]="opt" (change)="onRadioModelChange()">{{locale["LABEL_ROLE_GROUPS_" + opt.toUpperCase()] || opt}}</label>
          </a>
        </li>
      </ng-container>
      <h5 class="user-roles-header mb-0">User Roles</h5>
      <li *ngFor="let role of roles">
        <a href="javascript:void(0);">
          <label class="checkbox-wrapper">
            <input type="checkbox" [(ngModel)]="_model.checkboxModel[role]" [attr.id]="role" (change)="onCheckboxModelChange()">{{role}}</label>
        </a>
      </li>
    </ul>

  </div>
</div>
